// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"c6fe16cf","1657":"c6fe16cf","2491":"c6fe16cf","4317":"c6fe16cf","5450":"c6fe16cf","8961":"7fbb4256","9704":"c6fe16cf"}[chunkId] + ".chunk.css";
};